import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { UniAnswer } from "../dao/UniAnswer";
import { HisBasic } from "./HisBasic";
import { HisRow, SpwkHisStep } from "./HisRow";
import { HisRowParser_B02既往病史 } from "./HisRowParser_B02既往病史";
import { HisRowParser_B02自覺症狀 } from "./HisRowParser_B02自覺症狀";
import { HisRowParser_作業經歷 } from "./HisRowParser_作業經歷";
import { HisRowParser_既往病史_自覺症狀 } from "./HisRowParser_既往病史_自覺症狀";
import { HisRowParser_檢查時期 } from "./HisRowParser_檢查時期";
import { HisRowParser_環境監測 } from "./HisRowParser_環境監測";
import { HisRowParser_生活習慣 } from "./HisRowParser_生活習慣";
import { HisRowParser_疲勞狀況 } from "./HisRowParser_疲勞狀況";
import { SpwkMetaTable } from "./SpwkMetaTable";


export class HisRowHelper {





  static __ConvertTo_特作行(func_guid: string, func_code: string, ans: UniAnswer, meta_table: SpwkMetaTable, his_basic: HisBasic): HisRow[] {
    let re: HisRow[] = [];

    const steps = GetSpwkHisStepList(func_code);// 不同特作，解碼步驟可能略有不同

    for (const step of steps) {

      if (step.Chapter === SpwkUtilV3.CHAPTER_作業經歷) {// 2
        let data_row_list = HisRowParser_作業經歷.ConvertToHisRowList(step, func_code, his_basic, meta_table);
        re = re.concat(data_row_list);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_檢查時期) {// 3
        let data_row = HisRowParser_檢查時期.ConvertToHisRow(step, func_code, his_basic, meta_table);
        re.push(data_row);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_既往病史 || step.Chapter === SpwkUtilV3.CHAPTER_自覺症狀) {// 4、6
        let data_row = HisRowParser_既往病史_自覺症狀.ConvertToHisRow(step, his_basic, meta_table);
        re.push(data_row);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_既往病史_噪音作業) {// 4
        let data_row = HisRowParser_B02既往病史.ConvertToHisRow(step, his_basic, meta_table);
        re.push(data_row);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_自覺症狀_噪音作業) {// 6
        let data_row = HisRowParser_B02自覺症狀.ConvertToHisRow(step, his_basic, meta_table);
        re.push(data_row);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_生活習慣) {// 5
        let data_row_list = HisRowParser_生活習慣.ConvertToHisRow(step, his_basic, meta_table);
        re = re.concat(data_row_list);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_疲勞狀況) {// A98
        let data_row = HisRowParser_疲勞狀況.ConvertToHisRow(func_guid, step, his_basic, meta_table);
        re.push(data_row);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_環境監測) {// 7
        let data_row_list = HisRowParser_環境監測.ConvertToHisRow(func_guid, step, his_basic, meta_table);
        re = re.concat(data_row_list);

      } else {
        let err_msg = "未知的解碼步驟: " + step.Chapter + " !!!";
        alert("未知的解碼步驟: " + step.Chapter + " !!!");
        throw new Error(err_msg);
      }

    }

    return re;
  }




}



/**
* @param func_code - "A01"、"A98"...
*/
function GetSpwkHisStepList(func_code: string) {
  const re: SpwkHisStep[] = [];

  if (func_code === SpwkUtilV3.FUNC_CODE_A98) {
    re.push(new SpwkHisStep("3", SpwkUtilV3.CHAPTER_既往病史));// 4-->3
    re.push(new SpwkHisStep("4", SpwkUtilV3.CHAPTER_生活習慣));// 5--?4
    re.push(new SpwkHisStep("5", SpwkUtilV3.CHAPTER_自覺症狀));// 6-->5
    re.push(new SpwkHisStep("6", SpwkUtilV3.CHAPTER_疲勞狀況));// 6改為疲勞狀況

  } else if (func_code === SpwkUtilV3.FUNC_CODE_B02) {
    re.push(new SpwkHisStep("2", SpwkUtilV3.CHAPTER_作業經歷));
    re.push(new SpwkHisStep("3", SpwkUtilV3.CHAPTER_檢查時期));
    re.push(new SpwkHisStep("4", SpwkUtilV3.CHAPTER_既往病史_噪音作業));
    re.push(new SpwkHisStep("5", SpwkUtilV3.CHAPTER_生活習慣));
    re.push(new SpwkHisStep("6", SpwkUtilV3.CHAPTER_自覺症狀_噪音作業));
    re.push(new SpwkHisStep("7", SpwkUtilV3.CHAPTER_環境監測));

  } else {
    re.push(new SpwkHisStep("2", SpwkUtilV3.CHAPTER_作業經歷));// B01高溫要填 高溫訓練、B02聽力有特殊答案
    re.push(new SpwkHisStep("3", SpwkUtilV3.CHAPTER_檢查時期));
    re.push(new SpwkHisStep("4", SpwkUtilV3.CHAPTER_既往病史));
    re.push(new SpwkHisStep("5", SpwkUtilV3.CHAPTER_生活習慣));
    re.push(new SpwkHisStep("6", SpwkUtilV3.CHAPTER_自覺症狀));
    re.push(new SpwkHisStep("7", SpwkUtilV3.CHAPTER_環境監測));
  }

  return re;

}
